(function($){
	const $getSupportInput = $('#getSupportSearch');

	$getSupportInput.autocomplete({
		serviceUrl: '/ajax/support-topics',
		type: 'GET',
		dataType: 'json',
		paramName: 'terms',
      	onSelect: function (suggestion) {
			window.location.href = suggestion.data;
	    }
    });
})(jQuery);
